import { youtubeEmbedUrl } from "@/mocks/propertyMedia";

export default function VideoAndMap() {
  return (
    <div className="mt-8 space-y-10">
      {/* Video section */}
      <div>
        <h4 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <span className="w-1 h-5 bg-amber-600 rounded-full inline-block" />
          Film
        </h4>
        <div className="w-full aspect-video rounded-lg overflow-hidden bg-gray-100">
          <iframe
            width="100%"
            height="100%"
            src={youtubeEmbedUrl}
            title="Bydlino koło Ustki - rezydencja mieszkalna 9 km od morza"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            className="w-full h-full"
          />
        </div>
        <p className="text-xs text-gray-400 mt-2">słupski, Słupsk, Bydlino</p>
      </div>
    </div>
  );
}
